import React from "react";
import axios from "axios";

function ForgotPasswordForm({ onSwitchToSignIn }) {
    const [email, setEmail] = React.useState("");
    const [loading, setLoading] = React.useState(false);
    const [success, setSuccess] = React.useState(false);
    const [error, setError] = React.useState(null);

    const handleOnSubmit = async (evt) => {
        evt.preventDefault();
        setError(null);
        setLoading(true);

        try {
            const csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");
            await axios.post(
                '/api/v1/auth/forgot_password',
                { user: { email } },
                {
                    headers: {
                        'X-CSRF-Token': csrfToken,
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                }
            );
            setSuccess(true);
        } catch (err) {
            const msg = err.response?.data?.message
                || "Une erreur est survenue. Veuillez réessayer.";
            setError(msg);
        } finally {
            setLoading(false);
        }
    };

    if (success) {
        return (
            <div className="form-container sign-in-container">
                <div className="auth-form">
                    <h1 className="auth-title">Email envoyé !</h1>
                    <div style={{
                        color: '#38A169',
                        background: 'rgba(56,161,105,0.08)',
                        border: '1px solid rgba(56,161,105,0.30)',
                        borderRadius: '8px',
                        padding: '14px',
                        marginBottom: '20px',
                        fontSize: '14px',
                        textAlign: 'center',
                        width: '100%',
                        boxSizing: 'border-box'
                    }}>
                        ✅ Si un compte existe avec cet email, vous recevrez les instructions de réinitialisation dans quelques minutes. Pensez à vérifier vos spams.
                    </div>
                    <a
                        className="auth-link"
                        href="#"
                        onClick={(e) => { e.preventDefault(); onSwitchToSignIn && onSwitchToSignIn(); }}
                    >
                        ← Retour à la connexion
                    </a>
                </div>
            </div>
        );
    }

    return (
        <div className="form-container sign-in-container">
            <form className="auth-form" onSubmit={handleOnSubmit}>
                <h1 className="auth-title">Mot de passe oublié ?</h1>
                <p className="auth-paragraph" style={{ textAlign: 'center', marginBottom: '20px', fontSize: '14px' }}>
                    Entrez votre adresse email et nous vous enverrons les instructions pour réinitialiser votre mot de passe.
                </p>
                {error && (
                    <div style={{
                        color: '#7c2837',
                        background: 'rgba(124,40,55,0.08)',
                        border: '1px solid rgba(124,40,55,0.30)',
                        borderRadius: '8px',
                        padding: '10px 14px',
                        marginBottom: '12px',
                        fontSize: '13px',
                        fontWeight: '600',
                        textAlign: 'center',
                        width: '100%',
                        boxSizing: 'border-box'
                    }}>
                        ❌ {error}
                    </div>
                )}
                <input
                    type="email"
                    placeholder="Email"
                    name="email"
                    value={email}
                    className="auth-input"
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <button type="submit" className="auth-button" disabled={loading}>
                    {loading ? 'Envoi en cours…' : 'Envoyer les instructions'}
                </button>
                <a
                    className="auth-link"
                    href="#"
                    onClick={(e) => { e.preventDefault(); onSwitchToSignIn && onSwitchToSignIn(); }}
                >
                    ← Retour à la connexion
                </a>
            </form>
        </div>
    );
}

export default ForgotPasswordForm;
